/** @jsx jsx */
import { jsx } from '@emotion/core';
import React from 'react';
import { Field, FieldProps } from 'formik';
import { FormTextField } from 'components/TextField';

import useFieldCustomization from 'hooks/useFieldCustomization';
import useTranslate from 'hooks/useTranslate';
import withOptional from './withOptional';

const ReferralCodeField: React.FC = () => {
  const { isVisible, isRequired } = useFieldCustomization();
  const t = useTranslate();
  return (
    <React.Fragment>
      {isVisible('referralCode') && (
        <Field name="referralCode">
          {(fieldProps: FieldProps) => (
            <FormTextField
              id="creditAppReferralCode"
              fieldProps={fieldProps}
              required={isRequired('referralCode')}
              label={withOptional(
                t,
                'formLabel.referralCode',
                isRequired('referralCode'),
              )}
            />
          )}
        </Field>
      )}
    </React.Fragment>
  );
};

export default ReferralCodeField;
